export const getUserSelector = state => state.user.data;
export const getAllUserSelector = state => state.user.getAll;
export const getUserIsAuthSelector = state => state.user.isAuth;
export const getUserIsLoadingSelector = state => state.user.isLoading;
